module.exports = __webpack_public_path__ + "img/bernhard-kiener-v3.eb633fcd.jpg";